// Whole Component Tejashwini
import React, { useState, useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import AttributeIcon from "../images/attribute-01.png";
import { useNavigate } from "react-router-dom";
import ListAltIcon from "@mui/icons-material/ListAlt";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

export default function Attribute() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("attribute_id");
  const [isAddCategoryModal, setisAddCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState(0);
  const [attributeName, setattributeName] = useState("");
  const [attributevalue, setattributeValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [attributeNameError, setAttributeNameError] = useState(false);
  const [attribute, setattribute] = useState([{}]);
  const [categoryLabel, setCategoryLabel] = useState("Enter Attribute");
  const [newFieldValue, setNewFieldValue] = useState("");
  const [newFieldError, setNewFieldError] = useState(false);
  const [attributeLabel, setAttributeLabel] = useState("Enter Value");

  const navigate = useNavigate();
  const [isAddCategoryModals, setIsAddCategoryModals] = useState(false);
  const [rowsPerPages, setRowsPerPages] = useState(5);
  const [stockOrderBy, setStockOrderBy] = useState("created_timestamp");
  const [openForm, setOpenForm] = useState(false);
  const [stockOrder, setStockOrder] = useState("desc");
  const [stockLogs, setStockLogs] = useState([]);
  const [pages, setPages] = useState(0);
  const [stockLog, setStockLog] = useState({});
  const [editData, setEditData] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState();
  const [selectedAttributename, setSelectedAttributename] = useState();
  const [selectedAttributeId, setSelectedAttributeId] = useState(null);

  const openAddCategoryModal = (event) => {
    setisAddCategoryModal(true);
  };

  useEffect(() => {
    setOrder("desc");
    setOrderBy("attribute_id");
  }, []);

  const openEditCategoryModal = (attributeId) => {
    setCategoryId(attributeId);

    const selectedAttribute = paginatedRows.find(
      (row) => row.attribute_id === attributeId,
    );

    if (selectedAttribute) {
      setattributeName(selectedAttribute.attribute_name);
      setNewFieldValue(selectedAttribute.attribute_value);
    } else {
      setattributeName("");
      setNewFieldValue("");
    }

    setisAddCategoryModal(true);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  const reset = () => {
    setCategoryId("");
    setattributeName("");
    setattributeValue("");
    setCategoryLabel("Enter Attribute");
    setAttributeLabel("Enter Value");
    setNewFieldValue("");
    setAttributeNameError(false);
    setNewFieldError(false);
  };

  const resetSelectedRows = () => {
    setSelectedRows([]);
  };

  const getAttribute = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/getattribute",
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: "include",
        },
      );

      // 🔥 Handle 401 Unauthorized
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }

      const data = await response.json();

      if (!Array.isArray(data)) {
        throw new Error("Invalid response format: Expected an array");
      }

      setattribute(data);

      if (data.length > 0) {
        console.log("Attribute values:", data[0].attribute_value);
      }
    } catch (error) {
      console.error("Error fetching attribute data:", error);
    }
  };

  useEffect(() => {
    console.log("Updated attribute data:", attribute);
  }, [attribute]);

  const handleDelete = () => {
    if (selectedRows.length === 0) {
      setDeleteMsg("Please select attribute before deleting.");
      setIsConfirmationOpen(true);

      return;
    }
    setDeleteMsg("Are you sure you want to delete the selected attribute(s)?");
    setIsConfirmationOpen(true);
  }; 

  const confirmDelete = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/deleteAttribute",
        { attributeId: selectedRows }, // Correct placement of request body
        { withCredentials: true }, // Move withCredentials inside config object
      );

      // 🔥 Handle 401 Unauthorized
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return;
      }

      setSelectedRows([]);
      setIsConfirmationOpen(false);
      getAttribute();

      setSnackbarMessage("Attribute deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error deleting attribute:", error);

      // 🔥 Handle Unauthorized error inside catch block
      if (error.response && error.response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }

      setSnackbarMessage(
        "Cannot delete attribute. Attribute data is associated with one or more sections.",
      );
      setSelectedRows([]);
      setIsConfirmationOpen(false);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const cancelDelete = () => {
    resetSelectedRows();
    setIsConfirmationOpen(false);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = paginatedRows.map((row) => row.attribute_id);
      setSelectedRows(newSelecteds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxClick = (event, attribute_id) => {
    const newSelectedRows = event.target.checked
      ? [...selectedRows, attribute_id]
      : selectedRows.filter((id) => id !== attribute_id);
    setSelectedRows(newSelectedRows);
  };

  const handleClose = () => {
    setisAddCategoryModal(false);
    setattributeName("");
    setattributeValue("");
    setAttributeLabel("Enter Value");
    setCategoryLabel("Enter Attribute");
    setCategoryId(0);
    setAttributeNameError(false);
    setNewFieldError(false);
    resetSelectedRows();
    reset();
    getAttribute();
  };

  const handleQuantityClick = (attributeID) => {
    setSelectedAttribute(attributeID.attribute_id);
    setSelectedAttributename(attributeID.attribute_name);
    // setSelectedProduct(rowData);
    setIsAddCategoryModals(true);
    handleOpenForm();
  };

  useEffect(() => {
    setStockLogs([
      {
        attribute_value_id: "N/A",
        attribute_value: "N/A",
        attribute_id: "N/A",
        created_by_name: "Unknown",
        created_timestamp: "N/A",
        updated_by_name: "Unknown",
        updated_timestamp: "N/A",
      },
    ]);
  }, []);

  useEffect(() => {
    if (selectedAttribute) {
      // Ensure selectedAttribute is not null
      fetchAllStockLog(selectedAttribute);
    }
  }, [selectedAttribute]); // This runs when selectedAttribute changes

  const fetchAllStockLog = async (selectedAttribute) => {
    if (!selectedAttribute) {
      console.warn(
        "selectedAttribute is null or undefined. Skipping API call.",
      );
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/attribute/getAttributeValue?selectedAttribute=${encodeURIComponent(selectedAttribute)}`,
      );

      const data = await response.json();

      if (response.status === 200 && Array.isArray(data)) {
        setStockLogs(data);

        setPages(0);
        setRowsPerPages(5);
      } else {
        console.warn("No Attribute Value found.");
        setStockLogs([]);
      }
    } catch (error) {
      console.error("Error fetching Attribute Value:", error);
      setStockLogs([]);
    }
  };

  useEffect(() => {
    console.log("Stock logs updated:", stockLogs);
  }, [stockLogs]); // Runs when stockLogs changes

  const handleOpenForm = async () => {
    try {
      await fetchAllStockLog();

      setOpenForm(true);
    } catch (error) {
      console.error("Error before opening form:", error);
    }
  };
  useEffect(() => {
    console.log("Modal open state:", openForm);
  }, [openForm]);

  useEffect(() => {
    if (openForm) {
      setPages(0);
    }
  }, [openForm]);

  const handleCloseForm = () => {
    setPages(0);
    setOpenForm(false);
    setRowsPerPages(5);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setEditModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    setSelectedAttributeId(id);
    setDeleteMsg("Are you sure you want to delete the attribute value?");
    setIsConfirmationOpen(true);
  };

  const handleDeletes = async (id) => {
    if (!selectedAttributeId) return;

    try {
      await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/attribute/deleteAttributevalue",
        { attributeId: selectedAttributeId },
      );

      setIsConfirmationOpen(false);

      // 🔥 Fetch updated attributes dynamically
      await fetchAllStockLog(selectedAttribute);

      setSnackbarMessage("Attribute value deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error deleting attribute:", error);

      setSnackbarMessage(
        "Cannot delete attribute value. Attribute value data is associated with one or more sections.",
      );
      setIsConfirmationOpen(false);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setEditData(null);
    setNewFieldError(false); // ✅ Clear error state when closing
    setErrorMessage(""); // ✅ Clear error message when closing
    setEditData({ attribute_value: "" });
  };

  const handleSave = async () => {
    if (!(editData?.attribute_value || "").trim()) {
      setNewFieldError(true);
      setErrorMessage("* Attribute value is required");
      console.error("Attribute value cannot be empty.");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/saveAttributevalue",
        {
          attribute_attribute_id: selectedAttribute,
          attribute_value: editData.attribute_value,
          created_by: userId,
        },
      );

      if (response.status === 201) {
        setSnackbarMessage("Attribute value saved successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        handleEditClose();
        await fetchAllStockLog(selectedAttribute);
      }
    } catch (error) {
      console.error(
        "Error saving attribute:",
        error.response?.data || error.message,
      );

      setSnackbarMessage("Attribute value already exists.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleEditSubmit = async () => {
    const trimmedValue = (editData?.attribute_value || "").trim();

    if (!trimmedValue) {
      setNewFieldError(true);
      setErrorMessage("Attribute value is required");
      console.error("Attribute value cannot be empty.");
      return;
    }

    try {
      const response = await axios.put(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/editAttributevalue",
        {
          attribute_value_id: editData.attribute_value_id,
          attribute_value: trimmedValue,
          updated_by: userId,
          attribute_attribute_id: selectedAttribute,
        },
      );

      if (response.status === 200) {
        setSnackbarMessage("Attribute value updated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        handleEditClose();
        await fetchAllStockLog(selectedAttribute);
      }
    } catch (error) {
      console.error(
        "Error updating attribute:",
        error.response?.data || error.message,
      );

      const errorMessage =
        error.response?.data?.message || "Failed to update attribute";

      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleStockSortRequest = (columnId) => {
    const isAsc = stockOrderBy === columnId && stockOrder === "asc";
    setStockOrder(isAsc ? "desc" : "asc");
    setStockOrderBy(columnId);
  };

  const sortedStockLogs = useMemo(() => {
    if (!stockLogs || stockLogs.length === 0) return [];

    return stockOrderBy
      ? [...stockLogs].sort((a, b) => {
          if (a[stockOrderBy] === null) return 1;
          if (b[stockOrderBy] === null) return -1;
          if (a[stockOrderBy] === b[stockOrderBy]) return 0;

          return stockOrder === "asc"
            ? a[stockOrderBy] > b[stockOrderBy]
              ? 1
              : -1
            : a[stockOrderBy] < b[stockOrderBy]
              ? 1
              : -1;
        })
      : stockLogs; // Return unsorted data if no order is set
  }, [stockLogs, stockOrderBy, stockOrder]);

  useEffect(() => {
    console.log("Updated Attribute Value:", stockLog);
  }, [stockLog]); // Runs when stockLog changes

  const handleChangePages = (event, newPage) => {
    if (newPage >= 0 && newPage < Math.ceil(stockLogs.length / rowsPerPages)) {
      setPages(newPage);
    }
  };

  const handleChangeRowsPerPages = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setPages(0); // Reset to first page when changing rows per page
  };

  const validateFields = () => {
    let isValid = true;

    if (!attributeName || attributeName.toString().trim() === "") {
      setAttributeNameError(true);
      setCategoryLabel("* Attribute Required");
      isValid = false;
    } else {
      setAttributeNameError(false);
      setCategoryLabel("");
    }

    return isValid;
  };

  const saveAttribute = async () => {
    if (validateFields()) {
      const trimmedAttributeName = attributeName.trim(); // Remove leading/trailing white spaces
      const trimmedAttributeValue = newFieldValue.trim();

      const newAttribute = {
        attribute_name: trimmedAttributeName,
        attribute_value: trimmedAttributeValue,
        created_by: userId,
      };

      try {
        const response = await fetch(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/saveAttribute",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(newAttribute),
          },
        );

        // 🔥 Handle 401 Unauthorized
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect if unauthorized
          return;
        }

        if (response.ok) {
          const data = await response.json();
          setSnackbarMessage(data.message || "Attribute saved successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setOrder("desc");
          getAttribute(); // Refresh the list
          resetSelectedRows();
          handleClose();
        } else {
          const errorData = await response.json();
          if (response.status === 409) {
            setSnackbarMessage("Attribute already exists."); // Conflict message
          } else {
            setSnackbarMessage(
              errorData.message || "Failed to save attribute!",
            );
          }
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error(error);

        // 🔥 Handle Unauthorized error inside catch block
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }

        setSnackbarMessage("An error occurred while saving the Attribute.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };

  const editAttribute = async () => {
    if (validateFields()) {
      try {
        const payload = {
          attribute_id: categoryId,
          attribute_name: attributeName.trim(),
          updated_timestamp: new Date().toISOString(),
          updated_by: userId,
        };

        const response = await fetch(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/attribute/editAttribute",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(payload),
          },
        );

        // 🔥 Handle 401 Unauthorized
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to update attribute");
        }

        const data = await response.json();

        if (data.message) {
          setSnackbarMessage(data.message);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          reset();
          getAttribute(); // Refresh the list
          resetSelectedRows();
          setisAddCategoryModal(false);
        } else {
          throw new Error("No success message received");
        }
      } catch (error) {
        // 🔥 Handle Unauthorized error inside catch block
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }

        setSnackbarMessage("Attribute already exists.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        console.error("Error updating attribute:", error);
      }
    }
  };

  useEffect(() => {
    getAttribute();
  }, []);

  const handleAttributeNameChange = (event) => {
    resetSelectedRows();
    setattributeName(event.target.value);
  };

  const handleNewFieldValueChange = (event) => {
    resetSelectedRows();
    setNewFieldValue(event.target.value);
  };
  const handleChangePage = (event, newPage) => {
    resetSelectedRows();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    resetSelectedRows();
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    resetSelectedRows();
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleSortRequest = (property) => {
    resetSelectedRows();
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredRows = attribute.filter((row) => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    return searchTerms.every(
      (term) =>
        (row.attribute_id &&
          String(row.attribute_id).toLowerCase().includes(term)) ||
        (row.attribute_name && row.attribute_name.toLowerCase().includes(term)),
    );
  });

  const sortedRows = [...filteredRows].sort((a, b) => {
    if (orderBy === "attribute_id") {
      return (
        (order === "asc" ? 1 : -1) *
        (Number(a[orderBy] || 0) - Number(b[orderBy] || 0))
      );
    } else if (
      ["attribute_name", "created_by", "updated_by"].includes(orderBy)
    ) {
      return (
        (order === "asc" ? 1 : -1) *
        String(a[orderBy] || "").localeCompare(String(b[orderBy] || ""))
      );
    } else if (["created_timestamp", "updated_timestamp"].includes(orderBy)) {
      return (
        (order === "asc" ? 1 : -1) *
        (new Date(a[orderBy]) - new Date(b[orderBy]))
      );
    } else {
      return 0;
    }
  });

  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <>
      <Layout />
      <h1 className="title">Attribute</h1>

      <Dialog
        onClose={handleClose}
        open={isAddCategoryModal}
        sx={{
          "& .MuiDialog-paper": {
            width: "350px",
            height: "auto",
            maxHeight: "400px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle alignSelf={"center"} sx={{ padding: "1px 10px" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              color: "#0A64A2",
              fontSize: "1em",
              marginRight: "7em",
            }}
          >
            <img
              src={AttributeIcon}
              alt="category Image"
              style={{
                marginRight: "0.2px",
                width: "45px",
                height: "37px",
                position: "relative",
                top: "1.2em",
                left: "4%",
              }}
            />
            <span
              style={{
                color: "#0A64A2",
                fontSize: "1.2em",
                position: "relative",
                top: "1.3em",
                left: "0.6em",
              }}
            >
              {categoryId ? "Edit Attribute" : "Add Attribute"}
            </span>
          </span>
          <span
            style={{
              display: "block",
              position: "relative",
              borderBottom: "2.4px solid #0A64A2",
              width: "299px",
              top: "1.5em",
              left: "0.6em",
            }}
          />
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 4,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: "16px" }}>
          <Stack spacing={2} padding={1}>
            <TextField
              id="attribute-name"
              label={categoryLabel}
              value={attributeName}
              onChange={handleAttributeNameChange}
              error={attributeNameError}
              size="small"
              variant="outlined"
              sx={{ top: "1.3em", marginBottom: "1em" }}
            />

            <Button
              sx={{
                alignSelf: "center",
                width: "80px",
                height: "40px",
                padding: "12px 34px",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "#0A64A2",
                color: "white",
                left: "7.9em",
                top: "1em",
              }}
              variant="contained"
              onClick={categoryId ? editAttribute : saveAttribute}
            >
              {categoryId ? "Update" : "Save"}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      <Container>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              style={{ marginBottom: "0.3rem", border: "none" }}
              InputProps={{
                startAdornment: (
                  <SearchIcon sx={{ color: "gray", marginRight: "8px" }} />
                ),
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Button
              sx={{ width: "50%", right: "1%" }}
              variant="contained"
              className="blue-btn"
              onClick={handleDelete}
            >
              Delete
            </Button>
            <Button className="blue-btn" onClick={openAddCategoryModal}>
              Add Attribute
            </Button>
          </div>
          <Modal open={isConfirmationOpen} onClose={cancelDelete}>
            <Box sx={ModalStyle}>
              <Typography sx={{ fontSize: "1.1em", color: "#0A64A2" }}>
                {deleteMsg}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                {selectedRows.length === 0 ? (
                  ""
                ) : (
                  <Button
                    variant="contained"
                    onClick={confirmDelete}
                    className="no-btn"
                  >
                    Yes
                  </Button>
                )}
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  className="no-btn"
                >
                  {deleteMsg === "Please select attribute before deleting."
                    ? "Ok"
                    : "No"}
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <Modal open={openForm} onClose={handleCloseForm}>
          <Box
            sx={{
              position: "absolute",
              width: "69.5%",
              height: "auto",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header: Title row with close, then button row right-aligned */}
            <Box sx={{ display: "flex", flexDirection: "column", mb: 0 }}>
              {/* Close icon - top right corner of modal */}
              <IconButton
                aria-label="close"
                onClick={handleCloseForm}
                sx={{
                  color: "#A9A9A9",
                  position: "absolute",
                  top: 4,
                  right: 4,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              {/* Row 1: Title centered + Close icon absolute */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.7em",
                    fontWeight: "600",
                    color: "#2E82BD",
                    textAlign: "center",
                  }}
                >
                  Attribute Value(s) of {selectedAttributename}
                </Typography>
              </Box>

              {/* Row 2: Button right-aligned, no bottom margin */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 0.5,
                  mb: 0,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleEdit}
                  sx={{
                    backgroundColor: "#0A64A2",
                    color: "white",
                    height: "2.5em",
                    whiteSpace: "nowrap",
                    mb: 0.5,
                  }}
                >
                  Add Attribute Value
                </Button>
              </Box>
            </Box>

            {/* Table Container */}
            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: "white",
                maxHeight: rowsPerPages > 5 ? "60vh" : "auto",
                overflowY: rowsPerPages > 5 ? "auto" : "visible",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#0A64A2",
                      "& > th": {
                        backgroundColor: "#0A64A2",
                        color: "white",
                        borderBottom: "none",
                        textAlign: "center",
                        borderRight: "2px solid #0A64A2",
                      },
                      "& > th:last-child": { borderRight: "none" },
                    }}
                  >
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "#FFD700",
                        padding: "13  px",
                        minWidth: "120px",
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "attribute_value_id"}
                        direction={
                          orderBy === "attribute_value_id" ? order : "asc"
                        }
                        onClick={() =>
                          handleStockSortRequest("attribute_value_id")
                        }
                        sx={{ color: "white" }}
                      >
                        Attribute Value Id
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={orderBy === "attribute_value"}
                        direction={
                          orderBy === "attribute_value" ? order : "asc"
                        }
                        onClick={() =>
                          handleStockSortRequest("attribute_value")
                        }
                        sx={{ color: "white" }}
                      >
                        Attribute Value
                      </TableSortLabel>
                    </TableCell>

                    <TableCell align="center">
                      <TableSortLabel
                        active={orderBy === "created_by_name"}
                        direction={
                          orderBy === "created_by_name" ? order : "asc"
                        }
                        // onClick={() => handleStockSortRequest("created_by_name")}
                        sx={{ color: "white" }}
                      ></TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sortedStockLogs.length > 0 ? (
                    sortedStockLogs
                      .slice(
                        pages * rowsPerPages,
                        pages * rowsPerPages + rowsPerPages,
                      )
                      .map((log, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            height: "-0.0px",
                            backgroundColor:
                              index % 2 === 0 ? "#F5F5F5" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {log.attribute_value_id || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            {log.attribute_value || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => handleEdit(log)}
                              sx={{
                                color: "#2E82BD",
                                fontSize: "0.9em",
                                padding: "1px",
                                mt: "-2px", // ✅ Reduces the top spacing
                                right: "0.5em",
                              }}
                            >
                              <EditIcon sx={{ fontSize: "1.9em" }} />{" "}
                            </IconButton>
                            <IconButton
                              onClick={() =>
                                handleDeleteClick(log.attribute_value_id)
                              }
                              sx={{
                                color: "#A9A9A9",
                                fontSize: "0.9em",
                                padding: "1px",
                                mt: "-2px",
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: "1.9em" }} />
                            </IconButton>

                            <Modal
                              open={isConfirmationOpen}
                              onClose={cancelDelete} // ✅ Close modal when clicking outside
                              hideBackdrop={true} // ✅ Remove dark overlay
                              disableEscapeKeyDown={false} // ✅ Close modal with ESC key
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  ...ModalStyle,
                                  fontSize: "1.1em",
                                  backgroundColor: "white",
                                  boxShadow: 3,
                                  borderRadius: "8px",
                                  // p: 3
                                }}
                                onClick={(e) => e.stopPropagation()} // ✅ Prevent clicks inside from closing modal
                              >
                                <Typography
                                  sx={{ fontSize: "1.1em", color: "#0A64A2" }}
                                >
                                  {deleteMsg}
                                </Typography>

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    mt: 4,
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      handleDeletes(selectedAttributeId)
                                    }
                                    className="no-btn"
                                  >
                                    Yes
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={cancelDelete}
                                    className="no-btn"
                                    sx={{ ml: 2 }}
                                  >
                                    No
                                  </Button>
                                </Box>
                              </Box>
                            </Modal>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No Attribute Value available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Table Pagination */}
            <TablePagination
              component="div"
              sx={{
                backgroundColor: "#0A64A2",
                color: "white",
                width: "100%",
                minHeight: "56px", // Prevent shrinking
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end", // Align items to the right
                paddingRight: "1em", // Add some space from the right edge
              }}
              rowsPerPageOptions={[5, 10, 25]}
              count={stockLogs.length}
              rowsPerPage={rowsPerPages}
              page={pages}
              onPageChange={handleChangePages}
              onRowsPerPageChange={handleChangeRowsPerPages}
            />
          </Box>
        </Modal>

        <Modal open={editModalOpen} onClose={handleEditClose}>
          <Box
            sx={{
              position: "absolute",
              width: "350px",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "15px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              height: "13em",
              gap: 2,
              boxShadow: 3,
            }}
          >
            {/* Title Section with Icon */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={AttributeIcon}
                alt="Attribute Icon"
                style={{
                  width: "45px",
                  height: "37px",
                  marginRight: "8px",
                  position: "relative",
                  top: "1.4em",
                  right: "11%",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontSize: "1.5em",
                  fontWeight: "600px",
                  color: "#0A64A2",
                  right: "1.5em",
                  position: "relative",
                  top: "1.2em",
                }}
              >
                {editData?.attribute_value_id
                  ? "Edit Attribute Value"
                  : "Add Attribute Value"}
              </Typography>
            </Box>

            {/* Bottom Border */}
            <Box
              sx={{
                borderBottom: "2.4px solid #0A64A2",
                width: "96%",
                marginTop: "5px",
                position: "relative",
                top: "0.5em",
                left: "0.1em",
                height: "5em",
              }}
            />

            {/* TextField */}
            <TextField
              id="attribute-value"
              label={newFieldError ? errorMessage : attributeLabel} // ✅ Show error message inside field
              value={editData?.attribute_value || ""}
              onChange={(e) =>
                setEditData({ ...editData, attribute_value: e.target.value })
              }
              error={newFieldError} // ✅ Highlights the field in red
              size="small"
              variant="outlined"
              sx={{ marginTop: "0.5em", width: "19.5em" }}
            />

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleEditClose}
                sx={{
                  position: "absolute",
                  right: 4,
                  top: 4,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>

              {/* Save/Update Button */}
              <Button
                sx={{
                  alignSelf: "center",
                  width: "80px",
                  height: "40px",
                  padding: "10px 30px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  backgroundColor: "#0A64A2",
                  color: "white",
                  marginTop: "1em",
                  bottom: "1.5em",
                  left: "8em",
                }}
                variant="contained"
                onClick={
                  editData?.attribute_value_id ? handleEditSubmit : handleSave
                }
              >
                {editData?.attribute_value_id ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </Modal>

        <TableContainer component={Paper}>
          <div style={{ maxHeight: "", overflow: "hidden" }}>
            <Table>
              <TableHead
                style={{
                  height: "60px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                }}
              >
                <TableRow
                  style={{
                    cursor: "pointer",
                    height: "60px",
                    position: "sticky",
                  }}
                >
                  <StyledTableCell
                    padding="checkbox"
                    sx={{ width: "5%", textAlign: "center" }}
                  >
                    <Checkbox
                      color="primary"
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < paginatedRows.length
                      }
                      checked={
                        paginatedRows.length > 0 &&
                        selectedRows.length === paginatedRows.length
                      }
                      onChange={handleSelectAllClick}
                      inputProps={{
                        "aria-label": "select all attribute",
                      }}
                    />
                  </StyledTableCell>

                  {[
                    { id: "attribute_id", label: "Attribute Id" },
                    { id: "attribute_name", label: "Attribute Name" },
                    { id: "attribute_value", label: "Attribute Value" }, // No sorting here
                  ].map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align="center"
                      onClick={() =>
                        column.id !== "attribute_value" &&
                        handleSortRequest(column.id)
                      } // Disable sorting for attribute_value
                      sx={{
                        width: "12%",
                        padding: "8px",
                        position: "relative",
                        height: "60px",
                        "& .MuiTableSortLabel-root": {
                          display:
                            column.id === "attribute_value" ? "none" : "flex", // Hide arrow for attribute_value
                          alignItems: "center",
                          justifyContent: "center",
                          width: "120%",
                          height: "100%",
                          boxSizing: "border-box",
                          right: "2em",
                        },
                      }}
                    >
                      {column.id === "attribute_value" ? (
                        column.label // Just text, no sorting arrow
                      ) : (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : "asc"}
                        >
                          {column.label}
                        </TableSortLabel>
                      )}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedRows.map((row) => (
                  <StyledTableRow key={row.attribute_id} hover>
                    <StyledTableCell
                      padding="checkbox"
                      align="center"
                      style={{ textAlign: "center" }}
                    >
                      <Checkbox
                        color="primary"
                        checked={selectedRows.includes(row.attribute_id)}
                        onChange={(event) =>
                          handleCheckboxClick(event, row.attribute_id)
                        }
                        inputProps={{
                          "aria-label": `select attribute ${row.attribute_id}`,
                        }}
                      />
                    </StyledTableCell>

                    <StyledTableCell
                      onClick={() => openEditCategoryModal(row.attribute_id)}
                      align="center"
                      component="th"
                      scope="row"
                    >
                      {row.attribute_id}
                    </StyledTableCell>

                    <StyledTableCell
                      onClick={() => openEditCategoryModal(row.attribute_id)}
                      align="center"
                      style={{ cursor: "pointer" }}
                    >
                      {row.attribute_name}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      style={{
                        padding: "0",
                        marginLeft: "0",
                        paddingRight: "0px",
                      }}
                    >
                      <Button
                        onClick={() => handleQuantityClick(row)}
                        className="add-quantity-btn"
                      >
                        <ListAltIcon
                          style={{
                            marginRight: "0.2px",
                            height: "30px",
                            width: "60%",
                            color: "#0A64A2",
                            left: "20px",
                            position: "relative",
                            top: "0.2em",
                          }}
                        />
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </div>

          <TablePagination
            style={{ background: "#0A64A2", color: "#fff" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbarSeverity}
          sx={{ alignItems: "center", width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
